/**
 * MissionFilterTabs — Serif underline filter tabs
 *
 * Matches Figma mockup: Playfair Display text labels with underline active state.
 * No pill backgrounds. Active = dark text + border-bottom, inactive = grey text.
 *
 * @see Figma_assets/iOS/menu@2x.png
 */

import { cn } from '@ownyou/ui-design-system';

export interface MissionFilterTabsProps {
  activeFilter: string;
  onFilterChange: (filter: string) => void;
  className?: string;
}

const FILTERS = [
  { id: 'new', label: 'New' },
  { id: 'in_progress', label: 'In progress' },
  { id: 'snoozed', label: 'Snoozed' },
  { id: 'done', label: 'Done' },
] as const;

export function MissionFilterTabs({
  activeFilter,
  onFilterChange,
  className,
}: MissionFilterTabsProps) {
  return (
    <nav
      data-testid="mission-filter-tabs"
      role="navigation"
      aria-label="Mission filters"
      className={cn('flex gap-6', className)}
    >
      <div role="tablist" aria-label="Mission categories" className="flex gap-6">
        {FILTERS.map((filter) => {
          const isActive = activeFilter.toLowerCase() === filter.id;
          return (
            <button
              key={filter.id}
              role="tab"
              aria-selected={isActive}
              data-testid={`filter-${filter.id}`}
              onClick={() => onFilterChange(filter.id)}
              className={cn(
                'pb-2 font-display text-base transition-colors',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0F172A]',
                isActive
                  ? 'text-slate-100 font-semibold border-b-2 border-sky-400'
                  : 'text-slate-500 hover:text-slate-300',
              )}
            >
              {filter.label}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
